import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppSettings } from 'src/app.settings';

@Injectable({ providedIn: 'root' })
export class BrowserAppSettingsLoader {
  private readonly http = new HttpClient(inject(HttpBackend));

  async load(): Promise<AppSettings> {
    const raw = await firstValueFrom(this.http.get<AppSettings>('/config.json'));
    return new AppSettings(raw);
  }
}
